export default class RecentPressArticles {
  constructor() {
    this.$element = document.querySelector('.c-recent-press-articles');
    if (!this.$element) return;

    // DOM
    this.$filters = this.$element.querySelectorAll('.c-recent-press-articles__filter button');
    this.$cards = this.$element.querySelectorAll('.c-recent-press-articles__article');

    // Events
    this.$filters.forEach($filter => {
      $filter.addEventListener('click', this.filter.bind(this));
    })

    // Variables
    this.currentFilter = 'all';
  }
  /**
   * @function filter
   * @param {Event} e
   * Fired when the year select changes
   */
  filter(e) {
    this.currentFilter = e.target.dataset.value;

    this.$filters.forEach($filter => $filter.classList.remove('is-active'));

    e.target.classList.add('is-active');

    // Reset all cards
    if (this.currentFilter === 'all') {
      this.reset();
      return;
    }

    // Filter out cards that don't match the year filter
    this.$cards.forEach((card) => {
      if (card.dataset.year !== this.currentFilter) {
        card.style.display = 'none';
      } else {
        card.style.display = 'block';
      }
    });
  }

  reset() {
    this.$cards.forEach((card) => {
        card.style.display = 'block';
    });
  }
}
